export class DataBus {
  public event?: string;
  public data?: any;

  constructor(init?: DataBus) {
    Object.assign(this, init);
  }
}
